import { render, staticRenderFns } from "./PlaceInfo.vue?vue&type=template&id=06668f8e&"
import script from "./PlaceInfo.vue?vue&type=script&lang=js&"
export * from "./PlaceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports